import useAuth from '../hooks/useAuth';
import useClientMessagingVisibility from '../hooks/useClientMessagingVisibility';
import Forbidden from '../components/Forbidden';

type ClientMessagesGuardProps = {
    children: React.ReactNode;
};

export default function ClientMessagesGuard({ children }: ClientMessagesGuardProps) {
    const { isClient } = useAuth();
    const { isMessagingEnabled, loading } = useClientMessagingVisibility({ options: { skip: !isClient } });

    if (loading) return null;

    if (!isMessagingEnabled) return <Forbidden />;

    return <>{children}</>;
}
